<template>
  <v-app>
    <v-app-bar
      app
      color="blue lighten-3"
      dark
    >
      <div class="d-flex align-center">
        <!--
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />
        -->
        <!--
        <v-img
          alt="Acceso logo"
          class="shrink mr-2"
          contain
          src="http://appsistemas.edpymeaccesocrediticio.com.pe:1080/axesweb/layout/img/logo_acceso.png"          
          transition="scale-transition"
          width="180"
        />
        -->
        <v-btn
          href="https://acceso.com.pe"
          target="_blank"
          text
         >
         
          <v-img 
            src="./assets/logo_acceso.png"
            width="150"
          />
          
        </v-btn>

        <!--
        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        />
        -->
      </div>

      <v-spacer></v-spacer>
      <!--
      <v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
      -->
    </v-app-bar>

    <v-content>
      <HelloWorld/>
    </v-content>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>
